import { Brick, registerBrick } from 'olympe';
import { rgWrap, RGWrapper } from './helpers';

export default class RGWrapObject extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!*} object
     * @param {number} level
     * @param {function(!RGWrapper)} setWrapped
     */
    update(_$, [object, level], [setWrapped]) {
        setWrapped(rgWrap(object, level));
    }
}

registerBrick('019232c3d1873de0d259', RGWrapObject);
